import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Skills from './components/sections/Skills';
import Contact from './components/sections/Contact';
import ProjectDetail from './components/sections/ProjectDetail';
import ScrollProgress from './components/common/ScrollProgress';
import ScrollToTop from './components/common/ScrollToTop';
import SectionObserver from './components/common/SectionObserver';
import CursorSpotlight from './components/common/CursorSpotlight';
import './App.css';

// Location observer component to handle navigation state changes & smooth offset scrolling
function ScrollToSection() {
  const location = useLocation();

  useEffect(() => {
    const scrollToTarget = (targetId) => {
      const element = document.getElementById(targetId);
      if (element) {
        setTimeout(() => {
          const navbar = document.querySelector('.navbar');
          const navbarHeight = navbar ? navbar.offsetHeight : 70;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight - 16;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }, 80);
      }
    };

    if (location.state && location.state.scrollToSection) {
      scrollToTarget(location.state.scrollToSection);
    } else if (location.hash) {
      scrollToTarget(location.hash.substring(1));
    }
  }, [location]);

  return null;
}

// Home component rendering all core sections
function Home() {
  return (
    <main className="main-content">
      <Hero />
      <About />
      <Projects />
      <Skills />
      <Contact />
    </main>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('portfolio-theme');
    if (saved) return saved;
    return 'dark'; // Default to modern minimalist dark mode
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 450);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <div className="App">
        <CursorSpotlight />
        {loading ? (
          <div className="loading-screen">
            <div className="loader">
              <div className="loader-pulse"></div>
              <div className="loader-text">Luigi Santiago</div>
            </div>
          </div>
        ) : (
          <>
            <ScrollToSection />
            <ScrollProgress />
            <Navbar theme={theme} toggleTheme={toggleTheme} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project/:id" element={<ProjectDetail />} />
            </Routes>
            <SectionObserver />
            <ScrollToTop />
            <Footer />
          </>
        )}
      </div>
    </Router>
  );
}

export default App;